// extracted by mini-css-extract-plugin
export default {"switchGroup":"A0y9i","disabled":"nCrO1","name":"QGEQ3","popoverInfo":"WuqOe","popover":"INDZV","switch":"ppLQa"};